module.exports = __webpack_public_path__ + "img/00026.4f00de2e.webp";